import React, { useEffect } from "react"
import "./ProjectCard.css"
import "aos/dist/aos.css"
import Aos from "aos"
import { Link } from "react-router-dom"

function ProjectCard({
  animType1,
  animType2,
  imgUrl,
  content,
  name,
  showKnowMore
}) {
  useEffect(() => {
    Aos.init({
      // offset: 200,
      duration: 1000
      // easing: 'ease-in-sine',
      // delay: 100,
    })
  }, [])

  return (
    <div className="ProjectCardApp" data-aos={animType1}>
      <Link to={`/projects/${name}`}>
        <div className="project-card ">
          <img src={imgUrl} alt="" id="img-hide" />
          <h4>{name}</h4>
          {/* <p>Project Description</p> */}
        </div>
      </Link>

      <div className="data-of-project" data-aos={animType2}>
        <p>
          {" "}
          {content}&nbsp;
          {showKnowMore === "true" ? (
            <Link to={`/projects/${name}`}>Know More...</Link>
          ) : (
            ""
          )}
        </p>
      </div>
    </div>
  )
}

export default ProjectCard
